import { render, staticRenderFns } from "./FlipCardImg.vue?vue&type=template&id=4061f36d&scoped=true"
import script from "./FlipCardImg.vue?vue&type=script&lang=js"
export * from "./FlipCardImg.vue?vue&type=script&lang=js"
import style0 from "./FlipCardImg.vue?vue&type=style&index=0&id=4061f36d&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4061f36d",
  null
  
)

export default component.exports